<template>
  <div>
    <p v-if="description" class="text-muted pb-2">{{ description }}</p>
    <router-link to="/file/upload">
      <b-button class="spnod-admin__form--button mb-2" size="sm">Upload File</b-button>
    </router-link>
    <AdminTableContainer
      :users="localFiles"
      :headers="headers"
      :options="options" />
  </div>
</template>

<script>
import AdminTableContainer from '../../components/AdminTableContainer'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'FileMgmt',
  components: { AdminTableContainer },
  data() {
    return {
      localFiles: {},
      options: {
        sortable: true,
        actions: ['download', 'fileEdit']
      },
      description: null
    }
  },
  computed: {
    ...mapGetters(['files', 'getMyInfo']),
    isMobile() { return window.innerWidth < 768 },
    headers() {
      let result = ['name']
      if (!this.isMobile) result.push('description', 'owner')
      if (this.getMyInfo.hasRoles) result.push('sharedWith')
      return result
    }
  },
  methods: {
    ...mapActions(['getFiles', 'getDescription'])
  },
  mounted: async function () {
    const obj = await this.getDescription()
    this.description = obj.file
    await this.getFiles({})
    this.localFiles = this.files
  },
  watch: {
    files: {
      handler: function () {
        this.localFiles = this.files
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/FileMgmt/FileMgmt.vue?6a7d5e6e